export default "__VITE_ASSET__aqN1HNhq__"